
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more/[id]",
      function () {
        return require("private-next-pages/more/[id].js");
      }
    ]);
  